<script lang="ts">
    import {Link} from 'svelte-routing'
    import MainLayout from "../#common/layout/Layout.svelte"
    import image from 'src/components/main/404/image.svg'
    import background from 'src/components/main/404/background.jpg'
    import ops from 'src/components/main/404/ops.svg'
    import learnMore from 'src/components/main/#assets/learn-more.svg'
    import planet from 'src/components/main/404/planet.svg'
</script>

<svelte:head>
    <title>404 | Page not found</title>
    <meta name='robots' content='noindex, follow'/>
</svelte:head>

<MainLayout>
    <svelte:fragment slot="content">
        <section class="main-intro" style="--Background:url({background});">
            <div class="container">
                <img src="{planet}" class="planet-1" alt="">
                <img src="{planet}" class="planet-2" alt="">
                <img src="{planet}" class="planet-3" alt="">
                <img src="{planet}" class="planet-4" alt="">
                <div class="text-center">
                    <img src="{image}" class="image" alt="">
                </div>
                <div class="wrapper-404">
                     <div class="column">
                        <div class="ops"><img src="{ops}" alt=""></div>
                        <div class="description">Page Not Found</div>
                     </div>
                    <div class="column">
                        <Link to="/" class="big-btn">Go Home<img src="{learnMore}" alt=""></Link>
                    </div>
                </div>
            </div>
        </section>
    </svelte:fragment>
</MainLayout>

<style>
    .main-intro {
        padding: 210px 0 150px;
        background: var(--Background) no-repeat center;
        background-size: cover;
    }

    .container {
        position: relative;
    }

    .image {
        max-width: 100%;
        margin-bottom: 50px;
    }

    .wrapper-404 {
        width: 480px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
    }

    .ops {
        margin-bottom: 10px;
    }

    .description {
        font-size: 30px;
        line-height: 42px;
        color: white;
    }

    .wrapper-404 :global(.big-btn) {
        background: #0E1316 !important;
        margin-top: 35px;
    }

    .planet-1 {
        position: absolute;
        top: -50px;
        width: 24px;
        left: 50%;
        margin-left: -310px;
    }

    .planet-1 img,
    .planet-2 img,
    .planet-4 img {
        max-width: 100%;
    }

    .planet-2 {
        position: absolute;
        top: 400px;
        width: 64px;
        left: 50px;
    }

    .planet-3 {
        position: absolute;
        top: 640px;
        right: 50px;
    }

    .planet-4 {
        position: absolute;
        top: 710px;
        width: 20px;
        left: 50%;
        margin-left: -140px;
    }

    @media (max-width: 1199px) {
        .image {
            max-width: 500px;
        }
    }

    @media (max-width: 767px) {
        .main-intro {
            padding: 100px 0 70px;
            margin-bottom: -40px;
            overflow: hidden;
        }

        .image {
            max-width: 100%;
        }

        .wrapper-404 {
            width: 100%;
            flex-wrap: wrap;
            justify-content: center;
            text-align: center;
        }

        .description {
            font-size: 20px;
            line-height: 28px;
        }

        .wrapper-404 :global(.big-btn) {
            margin: 30px auto 0;
        }

        .ops img {
            max-width: 160px;
        }

        .planet-1 {
            top: -30px;
            width: 24px;
            left: 25%;
            margin-left: 0;
        }

        .planet-2 {
            left: -25px;
            top: 290px;
        }

        .planet-3 {
            top: 430px;
            right: -50px;
        }

        .column {
            width: 100%;
        }
    }
</style>
